import React from "react";
import TradingViewChart from "./TradingViewChart.jsx";

// Shows up to 3 companies side by side, each with a TradingView chart.
export default function TopCompanies({ title, companies }) {
  return (
    <section className="mb-5">
      <h5 className="fw-bold mb-3">{title}</h5>
      <div className="row g-3">
        {companies.slice(0, 3).map((c) => (
          <div key={c.symbol} className="col-12 col-lg-4">
            <div className="card top-company-card">
              <div className="top-company-header">
                <a className="fw-bold wl-company" href={`#/stock/${c.ticker}`}>{c.name}</a>
                <span className="text-muted small">{c.ticker}</span>
              </div>
              <TradingViewChart symbol={c.symbol} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
